export default __webpack_public_path__ + "static/media/file-tray-full-outline.ee920cba.svg";